import React from 'react';
import './SplashScreen.css';

const SplashScreen = ({ visible }) => {
  return (
    <div className={`splash-screen ${visible ? 'visible' : 'hidden'}`}>
      <div className="splash-content">
        <img
          src="/logo512.png"
          alt="KN Education Portal"
          className="splash-logo"
        />
        <h1 className="splash-title">KN Education Portal</h1>
        <p className="splash-tagline">Empowering Minds. Building Nation.</p>
      </div>
      <div className="splash-bar" />
    </div>
  );
};

export default SplashScreen;
